'use es6';

import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
const ProfileCardWrapper = props => {
  const {
    compact
  } = useResponsiveProps({
    compact: {
      xs: true,
      sm: true,
      md: true,
      lg: true,
      xl: false
    }
  });
  return /*#__PURE__*/_jsx(UICardWrapper, Object.assign({}, props, {
    compact: compact
  }));
};
export default ProfileCardWrapper;